import type { SVGProps } from 'react';

export const SvgIconNavService = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={49} height={48} viewBox="0 0 49 48" fill="none" {...props}>
    <g clipPath="url(#icon-nav-service_svg__a)">
      <path
        fill="#FF0019"
        fillRule="evenodd"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.974}
        d="m21.006 42.105-1.384-.799v-9.1l1.384.8z"
        clipRule="evenodd"
      />
      <path
        fill="#FF0019"
        fillRule="evenodd"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.974}
        d="m21.005 42.105 1.384-.799v-9.1l-1.384.8zM39.42 42.105l-1.384-.799v-9.1l1.384.8z"
        clipRule="evenodd"
      />
      <path
        fill="#FF0019"
        fillRule="evenodd"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.974}
        d="m39.42 42.105 1.383-.799v-9.1l-1.384.8zM30.208 47.215l-1.384-.799v-9.1l1.384.8zM30.213 47.215l1.383-.799v-9.1l-1.383.8z"
        clipRule="evenodd"
      />
      <path
        fill="#F5CE2F"
        fillRule="evenodd"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M30.213 38.437v-2.582l-10.59-6.114v2.582zM30.213 38.437v-2.582l10.59-6.114v2.582z"
        clipRule="evenodd"
      />
      <path
        fill="#FAEBAE"
        fillRule="evenodd"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m40.808 29.741-10.59 6.114-10.591-6.114c1.5-.872 2.62-1.515 10.59-6.118z"
        clipRule="evenodd"
      />
      <path
        fill="#FF0019"
        d="M15.298 40.784c1.053-.61 2.753-.61 3.795 0 1.048.609 1.038 1.593-.014 2.197l-2.587 1.49c-1.052.61-2.752.61-3.795 0-1.047-.609-1.038-1.593.015-2.197zM20.486 43.624c1.053-.61 2.753-.61 3.795 0 1.048.609 1.038 1.593-.014 2.197l-2.587 1.49c-1.052.61-2.753.61-3.795 0-1.047-.608-1.038-1.593.015-2.197z"
      />
      <path
        fill="#FBDED7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M24.759 29.838c-4.02 1.456-2.319-.059-6.377-1.404l-3.04 2.529c.653 8.198.926 10.386.926 10.386.872.765 1.856.765 2.762.01l.346-12.827h1.145l.71 15.545c1.029.804 2.34.53 2.924-.16 0 0 .994-7.138.599-14.075z"
      />
      <path
        fill="#FF0019"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M20.696 24.722s-4.95 1.69-6.157 4.107c-.648 1.296-1.145 4.365-1.082 5.188.107 1.403 10.255 6.109 12.963 3.673v-4.213s5.295-3.24 4.506-5.379l-2.99-2.508c-2.675-.268-7.24-.863-7.24-.863z"
      />
      <path
        fill="#FAEBAE"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m14.756 15.75 3.118-1.433 4.087 4.623c.604 2.84-3.77 4.087-4.866 1.856-.863-1.52-2.339-5.047-2.339-5.047"
      />
      <path
        fill="#FAEBAE"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19.464 12.69c.316-1.14 1.67-1.841 2.435-2.538.76-.692 3.26-1.418 3.26-1.418l5.324 1.418c1.783 1.115 3.512 3.6 3.196 5.68-.18 1.203-2.13 8.257-2.13 8.257l-.13 3.079c-2.514 2.777-9.193 1.267-12.296-2.324l.794-7.344s-1.462-1.176-.453-4.815z"
      />
      <path
        fill="#FBDED7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19.225 15.433c0 1.15.935 2.084 2.085 2.084s2.085-.935 2.085-2.085-.936-2.085-2.085-2.085-2.085.936-2.085 2.085"
      />
      <path
        fill="#FAEBAE"
        d="M29.124 18.852c-1.652-.404-5.407-3.069-5.407-3.069-1.126.405-1.647.877-2.017 2.217 1.067 1.286 2.226 2.572 3.273 3.551 1.671 1.398 3.635 2.533 5.617 1.33.809-.492 1.983-2.387 2.163-3.313"
      />
      <path
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M29.124 18.852c-1.652-.404-5.407-3.069-5.407-3.069-1.126.405-1.647.877-2.017 2.217 1.067 1.286 2.226 2.572 3.273 3.551 1.671 1.398 3.635 2.533 5.617 1.33.809-.492 1.983-2.387 2.163-3.313"
      />
      <path
        fill="#FF0019"
        stroke="#FF0019"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M19.56 10.678a.36.36 0 0 1 .15.273l-.019 7.711c0 .103-.068.142-.15.093l-3.153-1.92a.36.36 0 0 1-.15-.272l.019-7.712c0-.102.068-.141.15-.092z"
      />
      <path
        fill="#FBDED7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13.524 13.986c0 1.15.935 2.085 2.085 2.085s2.085-.936 2.085-2.085-.935-2.085-2.085-2.085-2.085.935-2.085 2.085M32.203 5.69a5.172 5.172 0 1 0-10.24 1.48 5.172 5.172 0 1 0 10.24-1.48"
      />
      <path
        fill="#FF0019"
        d="M27.507 5.644a.9.9 0 0 1 1.02.763.9.9 0 0 1-.764 1.019.9.9 0 0 1-1.018-.763.9.9 0 0 1 .762-1.019M25.306 6.227a.9.9 0 0 0-1.018-.763.9.9 0 0 0-.763 1.019c.07.49.528.833 1.019.762a.9.9 0 0 0 .762-1.018M39.188 9.558c.18-.147.448.019.404.248-.097.482-.414.98-.706 1.315-.292.336-.78.585-1.403.755-2.855.79-4.818-1.388-5.432-4.092l-.463-3.868a.25.25 0 0 1 .117-.268c1.428-.833 2.992-.993 4.005.322 1.403 2.031-.492 4.89.696 5.72.814.564 2.003.486 2.777-.123v-.01z"
      />
      <path
        fill="#FF0019"
        d="M28.29 1.188c2.539.663 3.727 2.82 3.596 4.726.107-.05-.132.048 0 0-3.508.107-6.684-2.066-6.86-4.555.605-.18 1.745-.6 3.27-.176z"
      />
      <path
        fill="#FF0019"
        d="M27.258 2.129c-.02.082-.166.209-.17.277-.819.95-3.518 2.796-4.809 2.11.098-.356.824-1.452 1.51-2.076 1.12-1.052 2.568-.974 3.474-.311z"
      />
      <path
        stroke="#FF0019"
        strokeWidth={1.5}
        d="M10.667 1.96h4M12.667 0v3.918M.917 14.694h4M2.917 12.735v3.918M43.917 7.837h4M45.917 5.878v3.918"
      />
    </g>
    <defs>
      <clipPath id="icon-nav-service_svg__a">
        <path fill="#fff" d="M.667 0h48v48h-48z" />
      </clipPath>
    </defs>
  </svg>
);
